<template>
  <div class="ui-box-item">
    <titleComponents :show.sync="show" name="宝宝信息"></titleComponents>
    <div class="itemInfo-detail" v-show="show">
      <table class="ui-box-table">
        <tr>
          <td style="width:19.36%">宝宝姓名</td>
          <td style="width:30.64%">{{baby.tbNickname||'-'}}</td>
          <td style="width:19.36%">性别</td>
          <td style="width:30.64%">{{baby.tbSex&&sexList[baby.tbSex - 1]||'-'}}</td>
        </tr>
        <tr>
          <td style="width:19.36%">出生年月</td>
          <td style="width:30.64%">{{data.babyBornTime||''}}</td>
          <td style="width:19.36%">体重</td>
          <td style="width:30.64%">{{baby.tbWeight&&baby.tbWeight+'kg'||'-'}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import titleComponents from '@/components/mother/title'
export default {
  name: 'babyInfo',
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    baby: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      sexList: ['男', '女'],
      show: true
    }
  },
  created () {

  },
  computed: {

  },
  methods: {},
  components: {
    titleComponents
  }
}
</script>

<style lang="scss" scoped>
.ui-box-item {
  margin: 20px 24px 0;
  background: rgba(0, 0, 0, 0.02);
  box-sizing: border-box;
  width: calc(100% - 48px);

  .itemInfo-detail {
    border-top: 1px solid #e5e5e5;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;

    .baseInfo-content {
      display: flex;
      align-content: center;
      margin-bottom: 25px;

      .text {
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        line-height: 22px;
        margin-right: 60px;
      }
    }

    .ui-box-table {
      table-layout: fixed;
      text-align: center;
      width: 62%;
      border: 1px solid #d8d8d8;
      border-radius: 6px;
      border-collapse: collapse;
      border-style: hidden;
      box-shadow: 0 0 0 1px #e0e0e0;
      overflow: hidden;

      tr {
        border: 1px solid #e0e0e0;
        height: 54px;
        line-height: 54px;

        th {
          background: #ffffff;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 700;
          color: #000000;
          text-align: center;
          border: 1px solid #e0e0e0;
        }

        td {
          background: #ffffff;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #000000;
          border: 1px solid #e0e0e0;

          .address {
            margin: 0 20px;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            line-height: 22px;
            font-style: normal;
            word-wrap: break-word;
            overflow-wrap: break-word;
            word-break: break-all;
          }

          .headImg {
            width: 46px;
            height: 46px;
            margin: 0 auto;

            &.background {
              background: #d8d8d8;
            }
          }
        }
      }
    }
  }
}
</style>